import CreateAdminPopup from './CreateAdminPopup';
import { submitFormData } from '../../../../HOCs';
import { createAdmin } from '../admin.ducks';

export default submitFormData(CreateAdminPopup, createAdmin);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdminPage/CreateAdminPopup/index.ts